import { ChangeDetectionStrategy, Component, input, model, output } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { Dialog } from 'primeng/dialog';
import { DatePicker } from 'primeng/datepicker';
import { Button } from 'primeng/button';

import { DialogoPadraoDirective } from '@/shared/components/layout/dialogo-padrao/dialogo-padrao.directive';
@Component({
    selector: 'app-encerrar-telemedicina-dialog',
    standalone: true,
    imports: [DialogoPadraoDirective, FormsModule, Dialog, DatePicker, Button],
    templateUrl: './encerrar-telemedicina.html',
    styleUrl: './encerrar-telemedicina.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
/** Diálogo de encerramento (data fim) de telemedicina. */
export class EncerrarTelemedicinaDialogComponent {
    // Controle externo do diálogo (padrão do sistema)
    showDialog = model.required<boolean>();

    // Nome do tipo selecionado para exibir no diálogo
    tipo = input<string>('');

    // Data fim a ser informada pelo usuário
    dataFim = model<Date | null>(null);

    // Eventos
    saved = output<string>(); // emite data no formato YYYY-MM-DD
    canceled = output<void>();

    hideDialog(): void {
        this.showDialog.set(false);
        this.dataFim.set(null);
    }

    onCancel(): void {
        this.canceled.emit();
        this.hideDialog();
    }

    salvar(): void {
        const iso = this.toIsoDateString(this.dataFim());
        this.saved.emit(iso);
        this.hideDialog();
    }

    private toIsoDateString(value: Date | string | null | undefined): string {
        if (!value) return '';
        try {
            const d = typeof value === 'string' ? new Date(value) : value;
            const yyyy = d.getFullYear();
            const mm = String(d.getMonth() + 1).padStart(2, '0');
            const dd = String(d.getDate()).padStart(2, '0');
            return `${yyyy}-${mm}-${dd}`;
        } catch {
            return String(value);
        }
    }
}
